export const SHOW_ALLPHOTO = "SHOW_ALLPHOTO";